import { useDispatch, useSelector } from "react-redux";
import { closeInspectionModal } from "../../../redux/reducer/modal.reducer";
import { MDBModalBody } from "mdb-react-ui-kit";
import FullModal from "../../../components/modal/full.modal";
import ConsignForm from "../components/consign.form";

export default function InspectionModal() {
  const dispatch = useDispatch();
  const { isOpenInspectionModal } = useSelector((state) => state.modal);

  const handleCloseInspection = () => {
    dispatch(closeInspectionModal());
  };

  return (
    <FullModal
      staticBackdrop={true}
      show={isOpenInspectionModal}
      close={handleCloseInspection}
      showCloseButton={true}
      screenSize="lg"
      className="overflow-hidden"
      dialogClassName="inspection-modal-dialog"
      contentClassName="inspection-modal"
      content={
        <MDBModalBody>
          <ConsignForm onSuccess={handleCloseInspection} />
        </MDBModalBody>
      }
    />
  );
}
